import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Environment } from '../../../environments/environment.interface';

export interface EnvironmentInfo {
  isActive: boolean;
  label: string;
}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly currentEnvironment: Environment = environment;

  private readonly ENV_PATTERNS = {
    DEV: {
      apiPattern: /dev-api\.insightstobehavior\.net/i,
      label: 'DEV',
    },
    STAGE: {
      apiPattern: /stage-api\.insightstobehavior\.net/i,
      label: 'STAGE',
    },
    PROD: {
      apiPattern: /api\.insightstobehavior\.net/i,
      label: '',
    },
  };

  get apiUrl(): string {
    return this.currentEnvironment.apiUrl;
  }

  get lmsUrl(): string {
    return this.currentEnvironment.lmsUrl;
  }

  get environmentInfo(): EnvironmentInfo {
    if (this.currentEnvironment.label !== undefined) {
      return {
        isActive: !!this.currentEnvironment.label,
        label: this.currentEnvironment.label,
      };
    }

    if (this.isDevelopment()) {
      return { isActive: true, label: 'DEV' };
    } else if (this.isStaging()) {
      return { isActive: true, label: 'STAGE' };
    } else if (this.isProduction()) {
      return { isActive: false, label: '' };
    }

    const apiUrl = this.currentEnvironment.apiUrl;
    for (const [, envConfig] of Object.entries(this.ENV_PATTERNS)) {
      if (envConfig.apiPattern.test(apiUrl)) {
        return {
          isActive: !!envConfig.label,
          label: envConfig.label,
        };
      }
    }

    return { isActive: false, label: '' };
  }

  getLogoutUrl(): string {
    const baseUrl = this.currentEnvironment.lmsUrl || '';
    if (!baseUrl) {
      if (this.isDevelopment()) {
        return 'https://dev-moodle.insightstobehavior.net/custom_logout.php';
      } else if (this.isStaging()) {
        return 'https://stage-moodle.insightstobehavior.net/custom_logout.php';
      } else {
        return 'https://moodle.insightstobehavior.net/custom_logout.php';
      }
    }
    return `${baseUrl}/custom_logout.php`;
  }

  isDevelopment(): boolean {
    return this.currentEnvironment.development === true;
  }

  isStaging(): boolean {
    return this.currentEnvironment.staging === true;
  }

  isProduction(): boolean {
    return this.currentEnvironment.production === true;
  }
}
